import {
    IAdServerTagTotals,
    IDataPoint,
    ITagMetrics, IPartner
} from "@leap4/entities-discrepancy-common";
import {DAYS} from "../../../../config/generals";
import {IDatapointOverview} from "../../dataPointOverview/interfaces";
import {IAdserverOverview} from "../../adServers/Overview/interfaces";
import {IPartnerOverview} from "../../partners/interfaces/IpartnerOverview";

export type OverviewValues = IDatapointOverview | IAdserverOverview | IPartnerOverview
type OverviewRenderValues = {
    adServer: any,
    entityName: string,
    totals: IAdServerTagTotals
    fillRate: number,
    profit: number,
    profitPercent: number,
    cpm: number,
    rpm: number,
    netProfit: number,
    incomingRequests: number,
}

export function extractOverviewValues(values: OverviewValues): OverviewRenderValues {
    const entityData = (values as IDatapointOverview).dataPoint || (values as IAdserverOverview).adServer || (values as IPartnerOverview).partner;
    const adServer = (entityData as IDataPoint).adServer || entityData;
    const side = (entityData as IPartner).side || entityData
    let entityName;
    if (side === entityData){
        entityName = entityData.name
    }
    else {
        entityName = entityData.name + " - " + side
    }
    const totals = (values as IDatapointOverview)?.metrics?.selectedDates.totals || (values as IAdserverOverview)?.selectedDates?.totals;
    const fillRate = ((totals?.impressions || 0) / (totals?.requests)) * 100
    const profit = (totals?.revenue || 0) - (totals?.cost || 0)
    const profitPercent = (profit / totals?.revenue || 0) * 100
    const netProfit =  (totals?.netRevenue || 0) - (totals?.netCost || 0)
    const cpm = totals?.impressions === 0 ? 0 : totals?.cost / totals?.impressions * 1000
    const rpm = totals?.impressions === 0 ? 0 : totals?.revenue / totals?.impressions * 1000
    const incomingRequests = totals?.incomingRequests
    return {adServer, entityName, totals, fillRate, profit, profitPercent, cpm, rpm, netProfit,incomingRequests, ...totals}
}

export function extractOverviewMetrics(metrics: ITagMetrics) {
    const {impressions, requests, revenue, cost, netRevenue, netCost, completion,serviceCost ,incomingRequests,fillRate:mFillRate,adFillRate:mAdFillRate} = metrics || {}
    const adFillRate = mFillRate || (((impressions || 0) / (requests)) * 100)
    const profit = (revenue || 0) - (cost || 0)
    const profitPercent = (profit / revenue) * 100
    const cpm = impressions === 0 ? 0 : cost / impressions * 1000
    const rpm = impressions === 0 ? 0 : revenue / impressions * 1000
    const netProfit = (netRevenue || 0) - (netCost || 0)
    const vcr = (impressions || 0) === 0 ? 0 : ((completion || 0) / (impressions)) * 100
    const fillRate = mAdFillRate || (((impressions || 0) / (incomingRequests || 0 )) *100)
    return {revenue, cost, profit, profitPercent, impressions, requests, fillRate, cpm, rpm, vcr, netRevenue, netCost, netProfit, completion,incomingRequests,adFillRate, serviceCost}
}

export function getColorByComparisonData(daysToCompare: number) {
    switch (daysToCompare) {
        case DAYS.ONE.value:
            return '#34a2eb'
        case DAYS.SEVEN.value:
            return '#ffa500'
        case DAYS.TWENTY_EIGHT.value:
            return '#ff1019'
        default:
            return 'green'
    }
}

export function getMetricChangePercent(metric1, metric2) {
    if (!metric1 || !metric2) {
        return null;
    }
    const numberToFormat = (metric1 / metric2) * 100 - 100
    const formattedNum = new Intl.NumberFormat('en', {
        style: 'percent',
        maximumFractionDigits: 2
    }).format(numberToFormat / 100)
    return formattedNum;
}
